export const resolveCatalogueSocialInsertIndex = (
  itemsLength: number,
  visibleColumns: number,
): number | null => {
  if (itemsLength <= 0 || !Number.isFinite(visibleColumns) || visibleColumns <= 0) {
    return null;
  }
  return Math.min(itemsLength, Math.floor(visibleColumns));
};
